export const Filters = {
  labelFilterCollectionDate: 'Recolha',
  labelFilterPromisseDate: 'Prometido'
}



// WEBPACK FOOTER //
// ./src/translations/pt/components/Filters.js